import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/services';
import { LoginResponse } from '../interfaces';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private _localStorageService = inject(LocalStorageService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Define los endpoints que requieren autorización
    const protectedEndpoints = [
      '/api/webapp-user-profile',
      '/api/gamification/passports',
      '/api/gamification/badges/seal',
    ];

    // Verifica si la URL del request es uno de los protegidos
    const isProtected = protectedEndpoints.some(endpoint => req.url.includes(endpoint));

    if (isProtected) {
      const loginResponseLocalStorage = this._localStorageService.getItem<LoginResponse>('loginResponse');
      if (!loginResponseLocalStorage) {
        return next.handle(req);
      }

      const token = loginResponseLocalStorage.data.access_token;
      
      if (token) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
        return next.handle(authReq);
      }
    }
    return next.handle(req);
  }
}